import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-iackathon-intro-page',
    imports: [
        MatIconModule,
        RouterLink,
        TranslateModule
    ],
  templateUrl: './iackathon-intro-page.component.html',
})
export class IackathonIntroPageComponent {

    public readonly descriptions = [
        {
            icon: 'grid_view_rounded_fill',
            text: 'iackathon.four_phase_workshop_description',
            title: 'iackathon.four_phase_workshop',
        },
        {
            icon: 'construction',
            text: 'iackathon.introduction_to_ai_description',
            title: 'iackathon.introduction_to_ai',
        },
        {
            icon: 'automation_fill',
            text: 'iackathon.design_thinking_approach_description',
            title: 'iackathon.design_thinking_approach',
        },
        {
            icon: 'key_vertical_fill',
            text: 'iackathon.key_skills_description',
            title: 'iackathon.key_skills',
        },
    ] as const;
}
